import styled from 'styled-components';

export const OldLandingPageImage = styled.img<{ isSixteenNineRatio: boolean }>`
  width: 100%;
  height: ${({ isSixteenNineRatio }) => (isSixteenNineRatio ? 'auto' : '100%')};
  object-fit: cover;
  top: 50%;
  left: 50%;
  position: absolute;
  border-radius: var(--way-design-borderRadiusDefault);
  object-position: center;
  transform: translate(-50%, -50%);
`;
